export { default as MediaComponent } from './MediaComponent'
export type { MediaComponentProps } from './MediaComponent'
export { default as mediaComponentFactory } from './MediaComponentFactory'
